<template>
  <div class="l-section wpb_row height_small mpc-row  card-carousel" :class="{_loading: pending}">
    <div class="l-section-h card-carousel__inner">
      <BasePreloader v-if="pending"/>
      <div class="card-carousel__head">
        <h3 class="card-carousel__title">{{ title }}</h3>
        <div class="card-carousel__nav-wrap"
             :class="{_disabled: swiperIsDisabled}"
        >
          <div class="card-carousel__pagination" ref="pagination"></div>
          <div class="card-carousel__navs carousel-navs">
            <button ref="slide-prev" type="button" class="carousel-navs__btn _prev">
              <i class="fa fa-arrow-left"></i>
            </button>
            <button ref="slide-next" type="button" class="carousel-navs__btn _next">
              <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="card-carousel__carousel">
        <div ref="carousel" class="card-carousel__container">
          <div class="card-carousel__list">
            <slot/>
          </div>
        </div>
        <div class="swiper-scrollbar" ref="scrollbar"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper'

  export default {
    name: 'CardCarousel',
    props: {
      title: {
        type: String
      },
      pending: {
        type: Boolean
      }
    },
    data() {
      return {
        swiper: null
      }
    },
    computed: {
      swiperIsDisabled() {
        if (!this.swiper) return true
        return this.swiper.isBeginning && this.swiper.isEnd
      }
    },
    methods: {
      createSwiper() {
        this.swiper = new Swiper(this.$refs['carousel'], {
          wrapperClass: 'card-carousel__list',
          slideClass: 'card-carousel__slide',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          observer: true,
          speed: 600,
          threshold: 2,
          navigation: {
            prevEl: this.$refs['slide-prev'],
            nextEl: this.$refs['slide-next'],
            disabledClass: '_disabled',
            hiddenClass: '_hidden',
            lockClass: '_hidden'
          },
          pagination: {
            el: this.$refs.pagination,
            type: 'fraction',
          },
          scrollbar: {
            el: this.$refs.scrollbar,
            draggable: true
          }
        })
      }
    },
    mounted() {
      this.createSwiper()
    },
    beforeDestroy() {
      if (this.swiper) {
        this.swiper.destroy()
      }
    }
  }
</script>

<style>

</style>
